export type ScanType = 'ASN' | 'LPN' | 'TN'

export type FlowType = 'Recepción' | 'Devoluciones'

export type UnknownOption = 'Prioridad' | 'SKU/EAN' | 'Proveedor' | 'Origen'

export const FLOW_TYPE_ID: Record<FlowType, number> = {
  'Recepción': 1,
  'Devoluciones': 2
}

export interface AsnLocateResult {
  asnId: number
  asnNumber: string
  supplierName: string
  supplierOriginName: string
  skuQty: number
  unitsQty: number
  brandName: string
  productOriginId: number
  withLpn: boolean
  priority: number
}

export interface LpnInfo {
  asnId: number
  lpn: string
  lpnStateId: number
  userId?: number
}

export interface AsnReceptionBatchHistoryDto {
  batchId: number
  batchNumber: string
  expirationDate?: string | null
  qty: number
}

export interface AsnReceptionPositionHistoryDto {
  positionName: string
  qty: number
  batchList: AsnReceptionBatchHistoryDto[]
}

export interface AsnReceptionSkuHistoryDto {
  skuId: number
  sku: string
  qty: number
  excessQty: number
  positionList: AsnReceptionPositionHistoryDto[]
}

export interface AsnLocateState {
  scanType: ScanType
  scanValue: string
  results: AsnLocateResult[]
  isLoading: boolean
  lpnList: LpnInfo[]
  lpnAsnId: number | null
  selectedLpn: string | null
  selectedResult: AsnLocateResult | null
  hideBackButton?: boolean
  stepTitle?: string
  defaultFlowType?: FlowType
}

export interface WorkOrderReceptionDetailInfoDto {
  lpn: string
  skuId: number
  sku: string
  ean: string
  skuName: string
  batchId?: number
  realQty: number
  controlledQty?: number
  locatedQty: number
}

export interface WorkOrderReceptionInfoDto {
  workOrderId: number
  asnId: number
  asnNumber: string
  brandName: string
  productOriginId: number
  asnCreatedDate: string
  warehouseId: number
  typeStorageId?: number
  typeOperationId?: number
  isReserveReception: boolean
  isPreSaleReception: boolean
  workOrderDetails: WorkOrderReceptionDetailInfoDto[]
}

export enum eStepAsnLocate{
  ScanStep = 0, 
  ResultsStep = 1,
  UnknownIdStep = 2,
  LpnStep = 3,
  LocateStepV2 = 4
}
